import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";
import Home from "@/pages/Home";
import PaymentResult from "@/pages/PaymentResult";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import AdminReset from "@/pages/AdminReset";
import ManageGift from "@/pages/ManageGift";
import Resources from "@/pages/Resources";
import Newsletter from "@/pages/Newsletter";
import OurStory from "@/pages/OurStory";

const AdminArea = ({ children }) => <AuthProvider>{children}</AuthProvider>;

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/payment/success" element={<PaymentResult />} />
        <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
        <Route path="/give/manage" element={<ManageGift />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/:slug" element={<Resources />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/our-story" element={<OurStory />} />
        <Route path="/admin/login" element={<AdminArea><AdminLogin /></AdminArea>} />
        <Route path="/admin/reset" element={<AdminArea><AdminReset /></AdminArea>} />
        <Route path="/admin" element={<AdminArea><ProtectedRoute><Admin /></ProtectedRoute></AdminArea>} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Toaster position="bottom-right" theme="light" />
    </BrowserRouter>
  );
}

export default App;
